export default {
    computed:{
        itemsPerPage: {
            get(){
              return this.$store.getters.getSelectedItemsPerPage
            },
            set(value){ 
              return this.$store.commit('setSelectedItemsPerPage', value)
            }
        },
        search: {
            get(){
              return this.$store.getters.getSearch
            },
            set(value){
              return this.$store.commit('setSearch', value)
            }
        },
        page: {
            get(){
              return this.$store.getters.getPage
            },
            set(value){
              return this.$store.commit('setPage', value)
            }
        },
        status: {
            get(){
              if(this.$store.getters.getStatus !== undefined){
                return this.$store.getters.getStatus
              }
              return ''
            },
            set(value){
              return this.$store.commit('setStatus', value)
            }
        },
        footerKey: {
            get(){
              return this.$store.getters.getFooterKey
            },
            set(value){
              return this.$store.commit('setFooterKey', value)
            }
        },
    },
    watch:{
        itemsPerPage: function(){
            this.refreshPage()
        }
    },
    methods:{
        searchInput(searched){
            this.search=searched
            this.refreshPage()
          },
          statusSelect(){
            this.refreshPage()  
          },
          refreshPage(){
            this.page=1
            this.setRequestInterval(this.page, this.itemsPerPage)
            this.footerKey++
          }
    }
  };